import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faHome } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight, faCheckCircle, faCircle, faCircleCheck, faDashboard, faMagnifyingGlass, faMap, faUser, faUserAlt, faUsers } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { faList } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
// import { menuCodeData } from "../Home/Access";
const AdminSideBar = () => {
    let menuCodeData = JSON.parse(localStorage.getItem("menuCodeData"));
    let zeroLevelMenu = [];
    let userManagementMenu = [];
    let masterMenu = [];
    function toggleClass() {
        document.getElementById("toggleli").childNodes[1].classList.toggle("collapse")
        document.getElementById("masterId").classList.add("collapse")
    }
    function masterClass() {
        document.getElementById("Master").childNodes[1].classList.toggle("collapse")
        document.getElementById("userManagementId").classList.add("collapse")
    }

    function handleSubMenuMaster() {
        var getId = document.getElementById("masterId")
        getId.classList.toggle("collapse")
    }

    function handleSubMenuUserManagement() {
        var getId2 = document.getElementById("userManagementId")
        getId2.classList.toggle("collapse")
    }

    menuCodeData.map((item, index) => {
       
        if(item.parentCode === 0) {
            zeroLevelMenu.push(item.menuTitle)
        }else if(item.parentCode === 2) {
            masterMenu.push(item.menuTitle)

        }else if(item.parentCode === 5) {
            userManagementMenu.push(item.menuTitle)
        }
    }) 

    return (

        <aside id="myDIV" className="sidebar">

            <ul className="sidebar-nav" id="sidebar-nav">

               <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/cropic/dashboard">
                        <i><FontAwesomeIcon icon={faHome} /></i>
                        <span> Dashboard</span>
                    </NavLink>
                </li>

               

                {zeroLevelMenu.includes("Crop Survey Details") ? <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/cropic/cropsurveydetails">
                        <i><FontAwesomeIcon icon={faMagnifyingGlass} /></i>
                        <span> Crop Survey Details</span>
                    </NavLink>
                </li> : "" }
                {zeroLevelMenu.includes("Crop Survey Map") ?  <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/cropic/mapview">
                        <i><FontAwesomeIcon icon={faMap} /></i>
                        <span> Crop Survey Map</span>
                    </NavLink>
                </li> : "" }
               
                { zeroLevelMenu.includes("User Management") ? <li className="nav-item" onClick={toggleClass} id="toggleli">
                    <b className="nav-link collapsed" >
                        <i><FontAwesomeIcon icon={faUsers} /></i>
                        <span> User Management</span>
                    </b>
                    <ul className="nav-content collapse" id="userManagementId">
                        
                        {/* This below code is for Cropic Sidebar */}
                     {userManagementMenu.map((item, index) => {
                        let routeLink = item.replace(/\s+/g, "").toLowerCase();
                      
                        if(item === "User Roles") {
                            routeLink = "userrolelist"
                        }
                        return (
                            <li id={index} key={index}>
                            <NavLink to= {`/usermanagement/${routeLink}`} onClick={handleSubMenuUserManagement}>
                                <i><FontAwesomeIcon icon={faArrowRight} /></i><span>{item}</span>
                            </NavLink>
                        </li>
                        )
                        
                     })}

                 

                     {/* This below code is for GCES sidebar */}

                        {/* <li >
                            <NavLink to= {`/GCES/usermanagement/centralofficer`} onClick={handleSubMenuUserManagement}>
                                <i><FontAwesomeIcon icon={faArrowRight} /></i><span>Central Officer</span>
                            </NavLink>
                        </li>
                        <li >
                            <NavLink to= {`/GCES/usermanagement/stateofficer`} onClick={handleSubMenuUserManagement}>
                                <i><FontAwesomeIcon icon={faArrowRight} /></i><span>State Officer</span>
                            </NavLink>
                        </li>
                        <li >
                            <NavLink to= {`/GCES/usermanagement/districtofficer`} onClick={handleSubMenuUserManagement}>
                                <i><FontAwesomeIcon icon={faArrowRight} /></i><span>District Officer</span>
                            </NavLink>
                        </li> */}

                    </ul>
                </li> : ""}
                { zeroLevelMenu.includes("Master") ? <li className="nav-item" onClick={masterClass} id="Master">
                    <b className="nav-link collapsed" to="/" >
                        <i><FontAwesomeIcon icon={faUser} /></i>
                        <span> Master</span>
                    </b>
                    <ul className="nav-content collapse" id="masterId">
                        

                    {masterMenu.map((item, index) => {
                        let routeLink = item.replace(/\s+/g, "").toLowerCase();
                      
                        if(routeLink === "forms") {
                           
                            routeLink = "formslist"
                        }
                       
                        return (
                            <li id={index} key={index}>
                            <NavLink to= {`/master/${routeLink}`} onClick={handleSubMenuMaster}>
                                <i><FontAwesomeIcon icon={faArrowRight} /></i><span>{item}</span>
                            </NavLink>
                        </li>
                        )
                     })}
                        {/* <li>
                            <NavLink to="/master/cropcategory">
                                <i><FontAwesomeIcon icon={faArrowRight} /></i> <span>Crop Category</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/master/crops">
                                <i><FontAwesomeIcon icon={faArrowRight} /></i> <span>Crop</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/master/cropstage">
                                <i><FontAwesomeIcon icon={faArrowRight} /></i> <span>Crop Stages</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/master/scheme">
                                <i><FontAwesomeIcon icon={faArrowRight} /></i> <span>Scheme</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/master/season">
                                <i><FontAwesomeIcon icon={faArrowRight} /></i> <span>Seasons</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/master/cropsintervaldays">
                                <i><FontAwesomeIcon icon={faArrowRight} /></i> <span>Crops Interval Days</span>
                            </NavLink>
                        </li> */}

                       
                    </ul>
                </li> : "" }

                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/home/access">
                        <i><FontAwesomeIcon icon={faDashboard} /></i>
                        <span> All Schemes</span>
                    </NavLink>
                </li>


            </ul>

        </aside>
    )

}

export default AdminSideBar;